import {FC, useState, createContext, useContext} from 'react'
import { BaseRequest } from '@/_metronic/helpers/crud-helper/base-request'
import { FilterPartnerOrganization, initialFilter } from './_models'
import { WithChildren } from '@/_metronic/helpers'

type ProductQueryRequestContextProps = {
  state: BaseRequest<FilterPartnerOrganization>
  updateState: (updates: Partial<BaseRequest<FilterPartnerOrganization>>) => void
}

const initialQueryRequest = {
  state: initialFilter,
  updateState: () => {},
}

const QueryRequestContext = createContext<ProductQueryRequestContextProps>(initialQueryRequest)

const QueryRequestProvider: FC<WithChildren> = ({children}) => {
  const [state, setState] = useState<BaseRequest<FilterPartnerOrganization>>(initialQueryRequest.state)

  const updateState = (updates: Partial<BaseRequest<FilterPartnerOrganization>>) => {
    const updatedState = {...state, ...updates} as BaseRequest<FilterPartnerOrganization>
    setState(updatedState)
  }

  return (
    <QueryRequestContext.Provider value={{state, updateState}}>
      {children}
    </QueryRequestContext.Provider>
  )
}

const useQueryRequest = () => useContext(QueryRequestContext)
export {QueryRequestProvider, useQueryRequest}